"use client";

import { useRouter } from "next/navigation";
import Button from "./Button";
import React from "react";
import { ILinkButton } from "@/hooks/types";

const LinkButton: React.FC<ILinkButton> = ({
  to,
  className,
  children,
  disabled = false,
}): React.JSX.Element => {
  // States
  const router = useRouter();

  // Functions
  const handleNavigation = (): void => {
    router.push(`/${to}`);
  };

  // Render
  return (
    <Button disabled={disabled} className={className} action={handleNavigation}>
      {children}
    </Button>
  );
};

export default LinkButton;
